import React, { useState } from "react";
import { Link } from "react-router-dom";
import { changePassword, translateAuthError } from "../../api/authApi";

// Section C (admin-only): lets the admin replace the password set via
// ADMIN_PASSWORD at bootstrap (see backend/cmd/api/main.go) with one only
// they know.
function AdminChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("token");

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setSuccess(false);

    if (newPassword !== confirmPassword) {
      setError("رمز عبور جدید و تکرار آن یکسان نیستند.");
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(token, currentPassword, newPassword);
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(translateAuthError(err.message));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin" className="back-link">
        ← بازگشت به پنل مدیریت
      </Link>

      <form className="auth-card admin-article-form" onSubmit={handleSubmit}>
        <span className="corner corner-tr" />
        <span className="corner corner-tl" />
        <span className="corner corner-br" />
        <span className="corner corner-bl" />

        <h2>تغییر رمز عبور</h2>

        {error && <p className="error">{error}</p>}
        {success && <p className="success">رمز عبور با موفقیت تغییر کرد.</p>}

        <div className="auth-field">
          <label htmlFor="current-password">رمز عبور فعلی</label>
          <input
            id="current-password"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <div className="auth-field">
          <label htmlFor="new-password">رمز عبور جدید</label>
          <input
            id="new-password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        <div className="auth-field">
          <label htmlFor="confirm-password">تکرار رمز عبور جدید</label>
          <input
            id="confirm-password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </div>

        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? "در حال ذخیره..." : "ذخیرهٔ رمز عبور جدید"}
        </button>
      </form>
    </div>
  );
}

export default AdminChangePasswordPage;
